import React, { useState } from 'react';
import Cards from '../Cards';
import AddFieldButton from '../AddFieldButton/AddFieldButton';
import './FormFieldWrapper.css';

const FormFieldWrapper = ({
  card,
  index,
  editItem,
  copyItem,
  copyToForm,
  deleteItem,
  moveCard,
  upItem,
  downItem,
  onFieldSelect,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="form-field-wrapper"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Cards
        key={card.id}
        index={index}
        id={card.id}
        type={card.type}
        text={card.text}
        config={card.config}
        editItem={editItem}
        copyItem={copyItem}
        copyToForm={copyToForm}
        deleteItem={deleteItem}
        moveCard={moveCard}
        upItem={upItem}
        downItem={downItem}
      />
      <AddFieldButton
        onFieldSelect={onFieldSelect}
        position={index + 1}
        className={isHovered ? 'visible' : ''}
      />
    </div>
  );
};

export default FormFieldWrapper;
